/*
 * Quiz Rejuderme v2
 * Navegação, estado, personalização e tracking.
 * Novidades vs v1: telas de transição, botão skip, contador de passos.
 */
(function () {
  'use strict';

  var IS_EDITOR = !!(window.Shopify && window.Shopify.designMode);
  var EDITOR_STATE_KEY = '_rej_quiz_v2_editor_block_id';
  var SKIP_FROM_QUESTION_INDEX = 3; // mostra skip a partir da 3ª pergunta respondida

  function bootQuiz() {
    var root = document.querySelector('[data-quiz-root][data-quiz-version="2"]');
    if (!root) return;

    // ----- Config vindo do Liquid -----
    var config = {
      pdpUrl: root.dataset.pdpUrl || '/products/plaquinha-do-colo',
      analyticsPrefix: root.dataset.analyticsPrefix || 'quiz_v2_',
      enableNameCapture: root.dataset.enableNameCapture === 'true',
      cookieDays: parseInt(root.dataset.cookieDays || '1', 10),
      apiEndpoint: root.dataset.apiEndpoint || '',
      apiToken: root.dataset.apiToken || '',
      swipe: root.dataset.swipe === '1',
      showSkip: root.dataset.showSkip === '1',
      reducedMotion: window.matchMedia('(prefers-reduced-motion: reduce)').matches
    };

    // ----- Seleção de telas -----
    var allScreens = Array.prototype.slice.call(root.querySelectorAll('.quiz-screen'));
    var screens = allScreens.filter(function (s) {
      if (s.dataset.screenType === 'name-capture' && !config.enableNameCapture) return false;
      return true;
    });

    if (!screens.length) return;

    if (!config.enableNameCapture) {
      allScreens.forEach(function (s) {
        if (s.dataset.screenType === 'name-capture') s.style.display = 'none';
      });
    }

    // ----- Estado -----
    var totalQuestions = screens.filter(function (s) { return s.dataset.screenType === 'question'; }).length;

    var state = {
      currentIndex: 0,
      answers: {},
      multiSelection: {},
      name: '',
      sessionUid: '',
      screenEnteredAt: Date.now(),
      questionsAnswered: 0
    };

    window.rejudermeQuizV2 = state;

    // ----- Cookies + UUID -----
    function setCookie(name, value, days) {
      var d = new Date();
      d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
      document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
    }
    function getCookie(name) {
      var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return match ? decodeURIComponent(match[1]) : '';
    }
    function uuidv4() {
      if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0;
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    }

    state.sessionUid = getCookie('_rej_quiz_v2_sid') || uuidv4();
    if (config.cookieDays > 0) setCookie('_rej_quiz_v2_sid', state.sessionUid, config.cookieDays);

    // ----- UTMs + contexto -----
    function parseUtms() {
      var params = new URLSearchParams(window.location.search);
      var utm = {};
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
        var v = params.get(k);
        if (v) utm[k.replace('utm_', '')] = v;
      });
      return utm;
    }
    function detectDevice() {
      var w = window.innerWidth || 0;
      if (w < 768) return 'mobile';
      if (w < 1024) return 'tablet';
      return 'desktop';
    }

    // ----- API -----
    function apiPost(path, payload) {
      if (!config.apiEndpoint) return Promise.resolve();
      var url = config.apiEndpoint.replace(/\/$/, '') + path;
      var headers = { 'Content-Type': 'application/json' };
      if (config.apiToken) headers['Authorization'] = 'Bearer ' + config.apiToken;
      return fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(payload),
        keepalive: true,
        credentials: 'omit',
        mode: 'cors'
      }).catch(function () {});
    }

    // ----- Analytics -----
    function trackEvent(name, data) {
      try {
        window.dataLayer = window.dataLayer || [];
        var payload = Object.assign({ event: config.analyticsPrefix + name }, data || {});
        window.dataLayer.push(payload);
      } catch (_) {}
    }

    // ----- Progress dots -----
    var progressBar = root.querySelector('[data-quiz-progress]');
    var stepDots = null;
    var stepLines = null;
    var finishEmoji = null;
    if (progressBar) {
      stepDots = Array.prototype.slice.call(progressBar.querySelectorAll('[data-step-dot]'));
      stepLines = Array.prototype.slice.call(progressBar.querySelectorAll('[data-step-line]'));
      finishEmoji = progressBar.querySelector('.quiz-progress-steps__finish');
    }

    function updateProgress() {
      var questionsSeen = 0;
      for (var i = 0; i <= state.currentIndex; i++) {
        if (screens[i] && screens[i].dataset.screenType === 'question') questionsSeen++;
      }
      var isLast = state.currentIndex >= screens.length - 1;

      if (stepDots) {
        stepDots.forEach(function (dot) {
          var step = parseInt(dot.dataset.stepDot, 10);
          dot.classList.remove('is-active', 'is-done');
          if (step === 0) {
            if (questionsSeen === 0 && !isLast) dot.classList.add('is-active');
            else dot.classList.add('is-done');
          } else if (step < questionsSeen || isLast) {
            dot.classList.add('is-done');
          } else if (step === questionsSeen) {
            dot.classList.add('is-active');
          }
        });
      }

      if (stepLines) {
        stepLines.forEach(function (line) {
          var step = parseInt(line.dataset.stepLine, 10);
          if (step <= questionsSeen || isLast) line.classList.add('is-done');
          else line.classList.remove('is-done');
        });
        // last connector (before finish)
        var lastLine = progressBar ? progressBar.querySelector('.quiz-progress-steps__connector--last') : null;
        if (lastLine) {
          if (isLast) lastLine.classList.add('is-done');
          else lastLine.classList.remove('is-done');
        }
      }

      if (finishEmoji) {
        finishEmoji.classList.toggle('is-done', isLast);
      }

      if (progressBar) progressBar.setAttribute('aria-valuenow', String(questionsSeen));

      // Scroll active dot into view
      if (stepDots) {
        var activeDot = stepDots.find(function (d) { return d.classList.contains('is-active'); });
        if (activeDot && progressBar) {
          try { activeDot.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); } catch (_) {}
        }
      }
    }

    function updateStepLabel() {} // label agora é visual (dots)

    // ----- Skip button -----
    var skipWrap = root.querySelector('[data-quiz-skip-wrap]');
    function updateSkipButton(index) {
      if (!skipWrap || !config.showSkip) return;
      var screen = screens[index];
      if (!screen) { skipWrap.hidden = true; return; }
      var type = screen.dataset.screenType;
      if (type === 'loading' || type === 'diagnosis' || type === 'welcome') {
        skipWrap.hidden = true;
        skipWrap.classList.remove('is-visible');
        return;
      }
      if (state.questionsAnswered >= SKIP_FROM_QUESTION_INDEX) {
        skipWrap.hidden = false;
        setTimeout(function () { skipWrap.classList.add('is-visible'); }, 50);
      } else {
        skipWrap.classList.remove('is-visible');
        setTimeout(function () { if (!skipWrap.classList.contains('is-visible')) skipWrap.hidden = true; }, 350);
      }
    }

    var skipBtn = root.querySelector('[data-quiz-skip]');
    if (skipBtn) {
      skipBtn.addEventListener('click', function () {
        var loadingIdx = -1;
        for (var i = 0; i < screens.length; i++) {
          if (screens[i].dataset.screenType === 'loading') { loadingIdx = i; break; }
        }
        if (loadingIdx >= 0) {
          trackEvent('skip_to_result', { questions_answered: state.questionsAnswered });
          showScreen(loadingIdx);
        }
      });
    }

    // ----- Botão voltar -----
    var backBtn = root.querySelector('[data-quiz-back]');
    function updateBackBtn() {
      if (!backBtn) return;
      var current = screens[state.currentIndex];
      var hide = !current
        || state.currentIndex === 0
        || current.dataset.screenType === 'loading'
        || current.dataset.screenType === 'diagnosis';
      backBtn.hidden = hide;
    }

    // ----- Navegação -----
    function showScreen(index) {
      if (index < 0 || index >= screens.length) return;
      var prev = screens[state.currentIndex];
      var next = screens[index];
      if (!next) return;

      if (prev && prev !== next) prev.classList.remove('is-active');
      next.classList.add('is-active');

      state.currentIndex = index;
      state.screenEnteredAt = Date.now();

      updateProgress();
      updateStepLabel(index);
      updateSkipButton(index);
      updateBackBtn();
      focusFirstInteractive(next);
      scrollScreenToTop(next);
      trackEvent('screen_view', { screen_index: index, screen_type: next.dataset.screenType });

      if (next.dataset.screenType === 'loading') runLoading(next);
      if (next.dataset.screenType === 'diagnosis') renderDiagnosis(next);
    }

    function focusFirstInteractive(screen) {
      var el = screen.querySelector('.quiz-option, input, .quiz-cta, [data-quiz-next], [data-quiz-name-submit]');
      if (el) { try { el.focus({ preventScroll: true }); } catch (_) {} }
    }

    function scrollScreenToTop(screen) {
      var anchor = root || screen;
      try {
        anchor.scrollIntoView({ behavior: config.reducedMotion ? 'auto' : 'smooth', block: 'start' });
      } catch (_) {
        var top = anchor.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo(0, top);
      }
    }

    function nextScreen() {
      var next = state.currentIndex + 1;
      while (next < screens.length && screens[next].dataset.screenType === 'name-capture' && !config.enableNameCapture) {
        next++;
      }
      showScreen(next);
    }

    function prevScreen() {
      var prev = state.currentIndex - 1;
      while (prev >= 0 && screens[prev].dataset.screenType === 'name-capture' && !config.enableNameCapture) {
        prev--;
      }
      showScreen(Math.max(0, prev));
    }

    // ----- Registrar resposta -----
    function recordAnswer(screen, value, label) {
      var qid = screen.dataset.questionId;
      var idx = Array.prototype.indexOf.call(screens, screen);
      var answerType = screen.dataset.answerType || 'single';
      var elapsed = Date.now() - state.screenEnteredAt;

      var answerValue, answerLabel;
      if (answerType === 'multi') {
        var set = state.multiSelection[qid] || [];
        answerValue = set.join(',');
        answerLabel = set.map(function (v) {
          var btn = screen.querySelector('[data-option-value="' + v + '"]');
          return btn ? btn.dataset.optionLabel : v;
        }).join(', ');
      } else {
        answerValue = value;
        answerLabel = label;
      }

      state.answers[qid] = answerType === 'multi' ? (state.multiSelection[qid] || []) : answerValue;
      state.questionsAnswered++;

      trackEvent('answer_' + qid, { value: answerValue });
      apiPost('/api/quiz/answer', {
        session_uid: state.sessionUid,
        question_id: qid,
        question_index: idx,
        answer_value: answerValue,
        answer_label: answerLabel,
        time_to_answer_ms: elapsed,
        quiz_version: 2
      });
    }

    // ----- Setup de handlers -----
    screens.forEach(function (screen) {
      var type = screen.dataset.screenType;

      // Welcome e Transition: mesma lógica
      if (type === 'welcome' || type === 'transition') {
        var nextBtn = screen.querySelector('[data-quiz-next]');
        if (nextBtn) nextBtn.addEventListener('click', function () { nextScreen(); });
      }

      if (type === 'question') {
        var options = Array.prototype.slice.call(screen.querySelectorAll('.quiz-option'));
        var answerType = screen.dataset.answerType || 'single';
        var qid = screen.dataset.questionId;
        var continueBtn = screen.querySelector('[data-quiz-continue]');

        options.forEach(function (opt) {
          opt.addEventListener('click', function () {
            var value = opt.dataset.optionValue;
            var label = opt.dataset.optionLabel;

            if (answerType === 'multi') {
              state.multiSelection[qid] = state.multiSelection[qid] || [];
              var list = state.multiSelection[qid];
              var i = list.indexOf(value);
              if (i === -1) {
                list.push(value);
                opt.classList.add('is-selected');
                opt.setAttribute('aria-checked', 'true');
              } else {
                list.splice(i, 1);
                opt.classList.remove('is-selected');
                opt.setAttribute('aria-checked', 'false');
              }
              if (continueBtn) continueBtn.disabled = list.length === 0;
            } else {
              options.forEach(function (o) {
                o.classList.remove('is-selected');
                o.setAttribute('aria-checked', 'false');
              });
              opt.classList.add('is-selected');
              opt.setAttribute('aria-checked', 'true');
              recordAnswer(screen, value, label);
              setTimeout(nextScreen, 220);
            }
          });
        });

        if (continueBtn) {
          continueBtn.addEventListener('click', function () {
            recordAnswer(screen);
            nextScreen();
          });
        }
      }

      if (type === 'name-capture') {
        var input = screen.querySelector('[data-quiz-name-input]');
        var submit = screen.querySelector('[data-quiz-name-submit]');
        if (input && submit) {
          submit.addEventListener('click', function () {
            var val = (input.value || '').trim();
            if (!val) { input.focus(); return; }
            state.name = val.charAt(0).toUpperCase() + val.slice(1);
            nextScreen();
          });
          input.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') submit.click();
          });
        }
      }

      if (type === 'diagnosis') {
        var primaryCta = screen.querySelector('[data-quiz-cta-primary]');
        if (primaryCta) {
          primaryCta.addEventListener('click', function (e) {
            e.preventDefault();
            trackEvent('cta_click');
            apiPost('/api/quiz/cta-click', { session_uid: state.sessionUid, quiz_version: 2 });

            try {
              fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
                body: 'attributes[rej_quiz_v2_sid]=' + encodeURIComponent(state.sessionUid),
                credentials: 'same-origin',
                keepalive: true
              }).catch(function () {});
            } catch (_) {}

            var baseUrl = primaryCta.getAttribute('href') || config.pdpUrl;
            var separator = baseUrl.indexOf('?') === -1 ? '?' : '&';
            var target = baseUrl + separator + 'rej_quiz_v2_sid=' + encodeURIComponent(state.sessionUid);
            setTimeout(function () { window.location.href = target; }, 120);
          });
        }

        var secondaryCta = screen.querySelector('[data-quiz-cta-secondary]');
        if (secondaryCta) {
          secondaryCta.addEventListener('click', function () {
            var faq = document.getElementById('quiz-faq') || screen.querySelector('.quiz-mechanism');
            if (faq) faq.scrollIntoView({ behavior: config.reducedMotion ? 'auto' : 'smooth', block: 'start' });
          });
        }
      }
    });

    if (backBtn) {
      backBtn.addEventListener('click', function () { prevScreen(); });
    }

    // ----- Loading screen -----
    function runLoading(screen) {
      var fill = screen.querySelector('[data-quiz-loading-fill]');
      var line = screen.querySelector('[data-quiz-loading-line]');
      var duration = parseInt(screen.dataset.duration || '3500', 10);
      var lines = line && line.dataset.lines ? line.dataset.lines.split('|') : [];

      trackEvent('loading_shown');
      apiPost('/api/quiz/session/complete', {
        session_uid: state.sessionUid,
        name: state.name || null,
        answers: state.answers,
        quiz_version: 2
      });

      if (config.reducedMotion) {
        if (fill) fill.style.width = '100%';
        setTimeout(nextScreen, 300);
        return;
      }

      if (fill) {
        fill.style.transitionDuration = duration + 'ms';
        requestAnimationFrame(function () { fill.style.width = '100%'; });
      }

      if (line && lines.length > 1) {
        var step = duration / lines.length;
        lines.forEach(function (txt, i) {
          if (i === 0) return;
          setTimeout(function () {
            line.classList.add('is-fading');
            setTimeout(function () {
              line.textContent = txt;
              line.classList.remove('is-fading');
            }, 180);
          }, Math.floor(step * i));
        });
      }

      setTimeout(function () {
        if (state.currentIndex === Array.prototype.indexOf.call(screens, screen)) nextScreen();
      }, duration + 120);
    }

    // ----- Mapas de personalização -----
    var DIAG_MAPS = {
      morning_state: {
        'liso': 'tem o colo sem marcas visíveis de manhã',
        'linhas-leves': 'percebe marcas que somem em poucas horas',
        'linhas-marcadas': 'acorda com linhas verticais visíveis',
        'padrao-fixo': 'tem marcas que não saem mais'
      },
      marks_pattern: {
        'sim-todo-dia': 'acorda quase todo dia com marcas no colo',
        'as-vezes': 'percebe marcas de vez em quando pela manhã',
        'raramente': 'raramente vê marcas pela manhã',
        'nao-percebia': 'nunca tinha reparado nisso antes'
      },
      sleep: {
        'lado-esquerdo': 'dormir do lado esquerdo',
        'lado-direito': 'dormir do lado direito',
        'alterno': 'alternar os dois lados ao dormir',
        'costas': 'dormir de costas',
        'bruco': 'dormir de bruços'
      },
      years: {
        'menos-5': 'há menos de 5 anos',
        '5-10': 'há 5 a 10 anos',
        '10-20': 'há mais de uma década',
        'mais-20': 'há mais de 20 anos'
      },
      concern: {
        'linhas-verticais': 'as linhas verticais entre os seios',
        'pele-crepada': 'a textura mais fina e crepada',
        'manchas': 'manchas e irregularidades no tom',
        'marcas-fixas': 'marcas que antes sumiam e agora ficaram',
        'tudo': 'a combinação de tudo isso junto'
      },
      situation: {
        'decote': 'pra você voltar a usar decote sem pensar duas vezes',
        'fotos': 'pra que as fotos com quem você ama voltem a ser tranquilas',
        'praia-piscina': 'pra você curtir praia e piscina sem disfarce',
        'intimidade': 'pra que os momentos íntimos voltem a ser só seus',
        'escondo': 'pra você parar de esconder o colo'
      },
      openness: {
        'ja-quero': '',
        'entender': 'Funciona nas noites que você já ia dormir mesmo — zero esforço extra.',
        'confortavel': 'É silicone fininho e macio, sem cola agressiva, confortável pra noite toda.',
        'ceticismo': 'Sem promessa mágica: mais de 12 mil mulheres brasileiras já testaram.'
      }
    };

    function buildPersonalizedIntro(answers, name) {
      var namePrefix = name ? name + ', ' : 'Olha, ';
      var morningState = DIAG_MAPS.morning_state[answers.v2q1_morning_state];
      var marks = DIAG_MAPS.marks_pattern[answers.v2q2_marks_pattern];
      var sleep = DIAG_MAPS.sleep[answers.v2q3_sleep_position];
      var years = DIAG_MAPS.years[answers.v2q4_years_sleeping];

      var primaryConcernVal = null;
      var concernArr = answers.v2q5_main_concern;
      if (concernArr && concernArr.length > 0) {
        primaryConcernVal = Array.isArray(concernArr) ? concernArr[0] : concernArr;
      }
      var concern = primaryConcernVal ? DIAG_MAPS.concern[primaryConcernVal] : null;

      var isBackSleeper = answers.v2q3_sleep_position === 'costas';
      var paragraphs = [];

      if (isBackSleeper) {
        paragraphs.push(namePrefix + 'você dorme de costas — o que é mais raro e, em princípio, menos lesivo pro colo.');
        if (concern) paragraphs.push('Mesmo assim, o que mais te incomoda hoje é ' + concern + '.');
        paragraphs.push('No seu caso, a causa principal é a perda de elasticidade e hidratação noturna' + (years ? ', agravada por ' + years + ' sem um cuidado específico pra essa região' : '') + '. A boa notícia: o mesmo protocolo resolve os dois cenários.');
      } else {
        var intro = namePrefix;
        if (morningState) {
          intro += 'você ' + morningState + '.';
        } else if (concern) {
          intro += 'o que mais te incomoda é ' + concern + '.';
        } else {
          intro += 'seu colo está pedindo um cuidado diferente do que você dá ao rosto.';
        }
        paragraphs.push(intro);

        if (marks) {
          paragraphs.push('E você ' + marks + '. Isso não é acaso — é o registro físico do que acontece enquanto você dorme, noite após noite.');
        }

        if (sleep && years) {
          paragraphs.push('A causa está em ' + sleep + ' ' + years + ': o colo passa horas dobrado na mesma direção e a pele começa a memorizar essa posição. Primeiro as marcas somem de manhã. Depois ficam.');
        } else if (sleep) {
          paragraphs.push('A causa está em ' + sleep + ': o colo fica dobrado na mesma direção horas seguidas e a pele memoriza essa posição.');
        }
      }

      return paragraphs.map(function (p) { return '<p>' + p + '</p>'; }).join('');
    }

    function buildPersonalNudge(answers, name) {
      var prefix = name ? name + ', ' : '';
      var ctx = DIAG_MAPS.situation[answers.v2q7_situation] || 'pra você voltar a ter o colo que já teve';
      var openTxt = DIAG_MAPS.openness[answers.v2q8_openness] || '';
      var line = prefix + 'pela combinação das suas respostas, esse é o caminho ' + ctx + '.';
      if (openTxt) line += ' ' + openTxt;
      return line;
    }

    // ----- Renderizar diagnóstico -----
    function renderDiagnosis(screen) {
      // Headline personalizada
      var headlineEl = screen.querySelector('[data-headline-template]');
      if (headlineEl) {
        var tpl = (headlineEl.dataset.headlineTemplate || '').trim();
        var fallback = headlineEl.dataset.headlineFallback || '';
        var name = state.name || '';
        var tokenRe = /%nome%|\{\{\s*nome\s*\}\}/g;
        var hasToken = tokenRe.test(tpl);
        tokenRe.lastIndex = 0;
        var rendered;
        if (!tpl) {
          rendered = fallback;
        } else if (hasToken && name) {
          rendered = tpl.replace(tokenRe, name);
        } else if (hasToken) {
          rendered = tpl.replace(/(?:%nome%|\{\{\s*nome\s*\}\})\s*,?\s*/g, '').trim();
          if (rendered) rendered = rendered.charAt(0).toUpperCase() + rendered.slice(1);
          if (!rendered) rendered = fallback;
        } else {
          rendered = tpl;
        }
        headlineEl.textContent = rendered;
      }

      // Seção B personalizada
      var sectionBDefault = screen.querySelector('[data-variant-target="section-b"] [data-variant="default"]');
      if (sectionBDefault) {
        sectionBDefault.innerHTML = buildPersonalizedIntro(state.answers, state.name);
      }

      var sectionBWrap = screen.querySelector('[data-variant-target="section-b"]');
      if (sectionBWrap) {
        var extras = sectionBWrap.querySelectorAll('.quiz-prose:not([data-variant="default"])');
        extras.forEach(function (el) { el.style.display = 'none'; });
      }

      // Nudge personalizado antes da oferta
      var offerSection = screen.querySelector('.quiz-offer');
      if (offerSection && !offerSection.querySelector('.quiz-personal-nudge')) {
        var nudge = document.createElement('p');
        nudge.className = 'quiz-personal-nudge';
        nudge.textContent = buildPersonalNudge(state.answers, state.name);
        offerSection.insertBefore(nudge, offerSection.firstChild);
      }

      trackEvent('diagnosis_shown');
      launchConfetti();
    }

    // ----- Confetti -----
    function launchConfetti() {
      if (config.reducedMotion) return;
      var canvas = document.createElement('canvas');
      canvas.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:9999;';
      document.body.appendChild(canvas);
      var ctx = canvas.getContext('2d');
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;

      var colors = ['#ff4a2c', '#ffb347', '#fff', '#ff8c69', '#ffd700', '#ff6b6b', '#ffa07a'];
      var particles = [];
      var count = 120;

      for (var i = 0; i < count; i++) {
        particles.push({
          x: Math.random() * canvas.width,
          y: -10 - Math.random() * 120,
          r: 4 + Math.random() * 6,
          color: colors[Math.floor(Math.random() * colors.length)],
          vx: (Math.random() - 0.5) * 3,
          vy: 2 + Math.random() * 4,
          angle: Math.random() * Math.PI * 2,
          spin: (Math.random() - 0.5) * 0.2,
          shape: Math.random() > 0.5 ? 'rect' : 'circle'
        });
      }

      var start = null;
      var duration = 3200;

      function draw(ts) {
        if (!start) start = ts;
        var elapsed = ts - start;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        var alive = false;
        particles.forEach(function (p) {
          p.x += p.vx;
          p.y += p.vy;
          p.vy += 0.07;
          p.angle += p.spin;
          ctx.save();
          ctx.globalAlpha = Math.max(0, 1 - elapsed / duration);
          ctx.translate(p.x, p.y);
          ctx.rotate(p.angle);
          ctx.fillStyle = p.color;
          if (p.shape === 'rect') {
            ctx.fillRect(-p.r, -p.r / 2, p.r * 2, p.r);
          } else {
            ctx.beginPath();
            ctx.arc(0, 0, p.r / 2, 0, Math.PI * 2);
            ctx.fill();
          }
          ctx.restore();
          if (p.y < canvas.height + 20) alive = true;
        });
        if (elapsed < duration && alive) {
          requestAnimationFrame(draw);
        } else {
          if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
        }
      }

      requestAnimationFrame(draw);
    }

    // ----- Teclado -----
    document.addEventListener('keydown', function (e) {
      var current = screens[state.currentIndex];
      if (!current) return;
      if (e.target && (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA')) return;

      if (e.key === 'ArrowLeft' && state.currentIndex > 0) {
        e.preventDefault();
        prevScreen();
      }
      if (e.key === 'Enter' && (current.dataset.screenType === 'welcome' || current.dataset.screenType === 'transition')) {
        var btn = current.querySelector('[data-quiz-next]');
        if (btn) btn.click();
      }
    });

    // ----- Swipe mobile -----
    if (config.swipe && !config.reducedMotion) {
      var touchStartX = 0, touchStartY = 0;
      root.addEventListener('touchstart', function (e) {
        var t = e.touches[0];
        touchStartX = t.clientX;
        touchStartY = t.clientY;
      }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (!e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;
        if (Math.abs(dx) < 60 || Math.abs(dy) > 40) return;
        var cur = screens[state.currentIndex];
        if (cur && (cur.dataset.screenType === 'loading' || cur.dataset.screenType === 'diagnosis')) return;
        if (dx > 0) prevScreen();
      }, { passive: true });
    }

    // ----- Theme editor helpers -----
    function findScreenIndexByBlockId(blockId) {
      if (!blockId) return -1;
      for (var i = 0; i < screens.length; i++) {
        if (screens[i].dataset.blockId === blockId) return i;
      }
      return -1;
    }

    function navigateToBlock(blockId) {
      var idx = findScreenIndexByBlockId(blockId);
      if (idx >= 0) showScreen(idx);
    }

    state.navigateToBlock = navigateToBlock;
    state.findScreenIndexByBlockId = findScreenIndexByBlockId;

    if (IS_EDITOR) {
      var _origShowScreen = showScreen;
      showScreen = function (index) {
        _origShowScreen(index);
        var cur = screens[state.currentIndex];
        if (cur && cur.dataset.blockId) {
          try { sessionStorage.setItem(EDITOR_STATE_KEY, cur.dataset.blockId); } catch (_) {}
        }
      };
    }

    // ----- Init -----
    function init() {
      screens.forEach(function (s) { s.classList.remove('is-active'); });
      if (screens[0]) screens[0].classList.add('is-active');
      updateProgress();
      updateStepLabel(0);
      updateSkipButton(0);
      updateBackBtn();

      if (IS_EDITOR) {
        var savedBlockId = null;
        try { savedBlockId = sessionStorage.getItem(EDITOR_STATE_KEY); } catch (_) {}
        if (savedBlockId) {
          var idx = findScreenIndexByBlockId(savedBlockId);
          if (idx > 0) showScreen(idx);
        }
        return;
      }

      trackEvent('start');
      apiPost('/api/quiz/session/start', {
        session_uid: state.sessionUid,
        quiz_version: 2,
        utm: parseUtms(),
        referrer: document.referrer || '',
        user_agent: navigator.userAgent || '',
        device: detectDevice()
      });
    }

    init();
  } // end bootQuiz

  bootQuiz();

  // ----- Theme editor integration -----
  if (IS_EDITOR) {
    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target || !e.target.querySelector) return;
      if (e.target.querySelector('[data-quiz-root][data-quiz-version="2"]') || e.target.matches('[data-quiz-root][data-quiz-version="2"]')) {
        bootQuiz();
      }
    });

    document.addEventListener('shopify:block:select', function (e) {
      var blockId = e.detail && e.detail.blockId;
      if (!blockId) return;
      try { sessionStorage.setItem(EDITOR_STATE_KEY, blockId); } catch (_) {}
      if (window.rejudermeQuizV2 && typeof window.rejudermeQuizV2.navigateToBlock === 'function') {
        window.rejudermeQuizV2.navigateToBlock(blockId);
      }
    });
  }
})();
